module.exports = __webpack_public_path__ + "static/media/pt1.fe284c88.jpg";